// TicketStatus.ts
/**
 * Enum or type for ticket status values (e.g., open, closed).
 * Used to track and display ticket progress.
 */

export const enum TicketStatus {
    OPENED,
    CLOSED
}

